module.exports = __webpack_public_path__ + "static/media/internal_env_2_media_10.f760b7eb.webp";